import { useEffect, useState } from "react";
import {
  Logo,
  LogoFull,
  LogoBlue,
  LogoDark,
  LogoFullBlue,
  LogoFullDark,
  LogoFullGreen,
  LogoFullOrange,
  LogoFullPink,
  LogoFullPurple,
  LogoFullWhite,
  LogoGreen,
  LogoOrange,
  LogoPink,
  LogoPurple,
  LogoWhite,
  LogoText,
  LogoFullText,
  LogoFullDarkOrange,
  LogoFullTurquoise,
} from "../AscIcons";
import AscLink from "../AscLink/AscLink";
import { AscBadgeColor, AscTrackBadgeColor } from "@ascendnow/shared";

type AscLogoVariants =
  | "primary"
  | "white"
  | "blue"
  | "dark"
  | "green"
  | "orange"
  | "pink"
  | "text"
  | "purple";

export interface AscLogoProps {
  href?: string | null;
  condensed?: boolean;
  className?: string;
  variant?: AscBadgeColor | AscTrackBadgeColor | AscLogoVariants;
  wrapperClassName?: string;
}

export default function AscLogo({
  href = "/",
  condensed,
  className,
  variant = "text",
  wrapperClassName,
}: AscLogoProps) {
  const [logo, setLogo] = useState<JSX.Element>(
    <LogoFull className={className} data-testid={"asc-logo-primary"} />
  );

  useEffect(() => {
    switch (variant) {
      case "primary":
        setLogo(
          condensed ? (
            <Logo
              className={className}
              data-testid={"asc-logo-primary-condensed"}
            />
          ) : (
            <LogoFull className={className} data-testid={"asc-logo-primary"} />
          )
        );
        break;
      case "white":
        setLogo(
          condensed ? (
            <LogoWhite
              className={className}
              data-testid={"asc-logo-white-condensed"}
            />
          ) : (
            <LogoFullWhite
              className={className}
              data-testid={"asc-logo-white"}
            />
          )
        );
        break;
      case "blue":
      case AscBadgeColor.TEAL:
        setLogo(
          condensed ? (
            <LogoBlue
              className={className}
              data-testid={"asc-logo-blue-condensed"}
            />
          ) : (
            <LogoFullBlue className={className} data-testid={"asc-logo-blue"} />
          )
        );
        break;
      case "dark":
        setLogo(
          condensed ? (
            <LogoDark
              className={className}
              data-testid={"asc-logo-dark-condensed"}
            />
          ) : (
            <LogoFullDark className={className} data-testid={"asc-logo-dark"} />
          )
        );
        break;
      case "green":
      case AscBadgeColor.GREEN:
        setLogo(
          condensed ? (
            <LogoGreen
              className={className}
              data-testid={"asc-logo-green-condensed"}
            />
          ) : (
            <LogoFullGreen
              className={className}
              data-testid={"asc-logo-green"}
            />
          )
        );
        break;
      case "orange":
      case AscBadgeColor.ORANGE:
        setLogo(
          condensed ? (
            <LogoOrange
              className={className}
              data-testid={"asc-logo-orange-condensed"}
            />
          ) : (
            <LogoFullOrange
              className={className}
              data-testid={"asc-logo-orange"}
            />
          )
        );
        break;
      case "pink":
      case AscBadgeColor.PINK:
        setLogo(
          condensed ? (
            <LogoPink
              className={className}
              data-testid={"asc-logo-pink-condensed"}
            />
          ) : (
            <LogoFullPink className={className} data-testid={"asc-logo-pink"} />
          )
        );
        break;
      case "purple":
      case AscBadgeColor.PURPLE:
        setLogo(
          condensed ? (
            <LogoPurple
              className={className}
              data-testid={"asc-logo-purple-condensed"}
            />
          ) : (
            <LogoFullPurple
              className={className}
              data-testid={"asc-logo-purple"}
            />
          )
        );
        break;
      case AscTrackBadgeColor.DARK_ORANGE:
        setLogo(
          condensed ? (
            <LogoOrange
              className={className}
              data-testid={"asc-logo-orange-condensed"}
            />
          ) : (
            <LogoFullDarkOrange
              className={className}
              data-testid={"asc-logo--dark-orange"}
            />
          )
        );
        break;
      case AscTrackBadgeColor.TURQUOISE:
        setLogo(
          condensed ? (
            <LogoBlue
              className={className}
              data-testid={"asc-logo-blue-condensed"}
            />
          ) : (
            <LogoFullTurquoise
              className={className}
              data-testid={"asc-logo-turquoise"}
            />
          )
        );
        break;
      case "text":
        setLogo(
          condensed ? (
            <LogoText
              className={className}
              data-testid={"asc-logo-text-condensed"}
            />
          ) : (
            <LogoFullText className={className} data-testid={"asc-logo-text"} />
          )
        );
        break;
    }
  }, [className, condensed, variant]);

  if (href && logo) {
    return (
      <AscLink
        className={wrapperClassName}
        href={href || "#"}
        innerWrapperTag="button"
      >
        {logo}
      </AscLink>
    );
  }
  return logo;
}
